/**
 * Indian currency formatter (lakh / crore aware).
 * @param {number} n
 */
export function fmtINR(n) {
    if (n == null || isNaN(n)) return "—";
    if (n >= 10000000) return `₹${(n / 10000000).toFixed(2)} Cr`;
    if (n >= 100000) return `₹${(n / 100000).toFixed(1)} L`;
    return `₹${Number(n).toLocaleString("en-IN")}`;
}

/**
 * Compact INR — no decimals for ranges.
 * @param {number} n
 */
export function fmtINRCompact(n) {
    if (n >= 10000000) return `₹${Math.round(n / 100000) / 100} Cr`;
    if (n >= 100000) return `₹${Math.round(n / 1000) / 100} L`;
    return `₹${Number(n).toLocaleString("en-IN")}`;
}
